import React from "react"
import { formatDateRange } from "./utilities"
const DateFormat = (props) => {
  const dateformat = formatDateRange(props)
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: dateformat,
      }}
    ></span>
  )
}
export default DateFormat
